import type { RoleConfig } from '../types.js';

export const hitman: RoleConfig = {
  id: 'hitman',
  faction: 'mafia',
  title: { ru: 'Киллер', uk: 'Кілер' },
  latin: 'HITMAN',
  number: '24',
  accent: '#ff6a6a',
  ability: {
    ru: 'Раз за игру совершает дополнительное независимое убийство — отдельно от основного хода мафии.',
    uk: 'Один раз за гру робить додаткове незалежне вбивство — окремо від основного ходу мафії.',
  },
  abilities: [
    // killGroup 'independent': the hitman's shot never joins the mafia group
    // tally — it queues separately (he can still be the tie-breaking
    // commander while his charge is unspent).
    { key: 'kill', phase: 'night', cadence: 'one-time', canSelfTarget: false, charges: 1, killGroup: 'independent' },
  ],
  reveals: { factions: ['mafia'] },
  victory: { type: 'mafia' },
  seniority: 50,
};
